// src/utils/orientationGate.js

const KEY = "lk_orientation_gate_v1";

/**
 * Founder-controlled: show intermittently, not permanently disabled.
 * Simple defaults:
 * - show if never dismissed
 * - else show again after N hours
 * You can tune N later.
 */
export function shouldShowOrientation({ hoursBetween = 24 } = {}) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return true;
    const data = JSON.parse(raw);
    const lastDismissed = data?.lastDismissed || 0;
    const ms = hoursBetween * 60 * 60 * 1000;
    return Date.now() - lastDismissed > ms;
  } catch {
    return true;
  }
}

export function markOrientationDismissed() {
  try {
    localStorage.setItem(KEY, JSON.stringify({ lastDismissed: Date.now() }));
  } catch {
    // ignore
  }
}
